import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Card } from "react-bootstrap";

ChartJS.register(ArcElement, Tooltip, Legend);

export type DoughnutChartProps = {
  width?: string;
  chartTitle: string;
  labels: string[];
  chartData: DoughnutChartData;
};

export interface DoughnutChartData {
  data: number[];
  borderColor: string[];
  backgroundColor: string[];
}

export function DoughnutChart({
  width,
  chartTitle,
  labels,
  chartData,
}: DoughnutChartProps) {
  const data = {
    labels,
    datasets: [
      // {
      //   label: chartTitle,
      //   data: [12, 19, 3, 5, 2, 3],
      //   backgroundColor: [
      //     "rgba(255, 99, 132, 0.2)",
      //     "rgba(54, 162, 235, 0.2)",
      //     "rgba(255, 206, 86, 0.2)",
      //     "rgba(75, 192, 192, 0.2)",
      //     "rgba(153, 102, 255, 0.2)",
      //     "rgba(255, 159, 64, 0.2)",
      //   ],
      //   borderColor: [
      //     "rgba(255, 99, 132, 1)",
      //     "rgba(54, 162, 235, 1)",
      //     "rgba(255, 206, 86, 1)",
      //     "rgba(75, 192, 192, 1)",
      //     "rgba(153, 102, 255, 1)",
      //     "rgba(255, 159, 64, 1)",
      //   ],
      //   borderWidth: 1,
      // },
      {
        label: `Events`,
        data: chartData?.data ?? [],
        backgroundColor: chartData?.backgroundColor ?? [],
        borderColor: chartData?.borderColor ?? [],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      title: {
        display: true,
        text: chartTitle,
      },
    },
  };

  return (
    <Card style={{ backgroundColor: "#f8f9fa", width: width, height: width }}>
      <Card.Body>
        <Doughnut data={data} options={options} />
      </Card.Body>
    </Card>
  );
}
